module.exports = __webpack_public_path__ + "static/media/3.8-fern.d83ad057.webm";